<template>
  <div class="uom-admin">
    <v-card>
      <v-card-title data-cy="title">
        Units of Measure
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          :prepend-icon="svgMagnify"
          label="Search"
          clearable
          style="margin-left:250px;"
        ></v-text-field>
      </v-card-title>

      <v-card-actions class="mb-1">
        <v-spacer></v-spacer>
        <v-btn data-cy="plus-btn" text @click="addUom()">
          <v-icon>
            {{ svgPlus }}
          </v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table :headers="headers" :items="items" :search="search" :items-per-page="5" class="elevation-1">
        <template v-slot:item.action="{ item }">
          <v-icon @click="editItem(item)">
            {{ svgPencil }}
          </v-icon>
          <v-icon @click="deleteItem(item)">
            {{ svgDelete }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card v-if="selectedUom">
        <v-card-title class="text-h5 grey lighten-2" primary-title> Delete - {{ selectedUom.name }} </v-card-title>

        <v-card-text>
          Press OK to delete this unit of measure.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteUom()">OK</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiPencil, mdiDelete, mdiMagnify, mdiPlus } from "@mdi/js";

export default {
  name: "Uom",
  components: {},
  data: () => {
    return {
      search: "",
      svgPlus: mdiPlus,
      svgMagnify: mdiMagnify,
      svgPencil: mdiPencil,
      svgDelete: mdiDelete,
      dialog: false,
      selectedUom: null,
      pagination: {
        sortBy: "name",
        descending: true,
        rowsPerPage: 5,
      },
      headers: [
        { text: "ID", value: "id" },
        {
          text: "Unit of Measure",
          align: "left",
          value: "name",
          "must-sort": true,
        },
        { text: "Description", value: "description" },
        { text: "Action", value: "action", sortable: false, width: "10%" },
      ],
    };
  },
  beforeCreate() {},

  created() {
    this.$store.dispatch("getUomList");
  },

  mounted() {},

  beforeDestroy() {},

  computed: {
    ...mapGetters({
      items: "getUomList",
    }),
  },

  methods: {
    deleteItem(item) {
      if (!item) {
        return;
      }
      this.selectedUom = item;
      this.dialog = true;
    },
    deleteUom() {
      this.dialog = false;
      if (!this.selectedUom) {
        return;
      }
      this.$store.dispatch("deleteUom", this.selectedUom);
    },
    editItem(item) {
      if (!item) {
        return;
      }
      this.selectedUom = item;
      this.$store.dispatch("selectedUom", item);
      this.$router.push({ name: "UomDetails" });
    },
    addUom() {
      this.$store.dispatch("selectedUom", null);
      this.$router.push({ name: "UomDetails" });
    },
  },
};
</script>

<style lang="scss">
.uom-admin {
}
</style>
